
























































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig, UseModal } from "@/components/root/modal";
import SimpleNavTabs from "@/components/SimpleNavTabs.vue";
import { UseTabs } from "@/common/composition/use-tabs";
import { state } from "../data/state";
import { computed } from "@vue/composition-api";
import { OverviewItem, OverviewType } from "../data/model";
import PremiumModalVue from "@/components/premium/PremiumModal.vue";
import ThemeImg from "@/components/ThemeImg.vue";
export default Vue.extend({
  components: {
    Modal,
    SimpleNavTabs,
    ThemeImg,
  },
  props: ["modalData"],
  setup(_, { emit }) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "60rem",
      height: "42rem",
      withTopRightCloseBtn: true,
    };

    const {
      tabs,
      selected_tab,
      set_selected_tab,
      current_overview,
      overview_sources,
      select_current_overview_source,
    } = state;

    const display_sources = computed(() => {
      return overview_sources.value.filter(
        (d) => d.type == selected_tab.value.id && !d.hide_in_sources_modal
      );
    });
    // @ts-ignore
    window.display_sources = display_sources;

    const on_source_selected = async (source: OverviewItem) => {
      if (!source.is_licensed) {
        await UseModal().show(PremiumModalVue, {
          key: "m365atrest-popup-2024",
        });
      } else {
        select_current_overview_source(source);
        emit("submit");
      }
    };

    return {
      config,
      tabs,
      selected_tab,
      set_selected_tab,
      current_overview,
      display_sources,
      on_source_selected,
    };
  },
});
